import { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useIsMobile } from "../../../../../hooks";
import styles from "./CategoryHeaderDescription.css";

// eslint-disable-next-line complexity
const CategoryHeaderDescription = ({ viewport, description, device }) => {
  if (!description) {
    return null;
  }
  const isMobile = useIsMobile();
  const [expanded, setExpanded] = useState(false);
  const deviceClass =
    device === "mobileOnly" ? styles.mobileOnly : styles.desktopOnly;

  useEffect(() => {
    setExpanded(false);
  }, [isMobile]);

  const onClick = useCallback(() => {
    setExpanded(prev => !prev);
  }, [viewport]);

  return (
    <div className={deviceClass}>
      <button
        className={styles.button}
        aria-controls="descriptionContainer"
        aria-expanded={expanded}
        onClick={onClick}
      >
        <div className={styles.container} id="descriptionContainer">
          <p
            className={classNames(styles.shortenedDescription, {
              [styles.hide]: expanded
            })}
          >
            {description}
          </p>
          {!expanded && description && (
            <span className={styles.ellipsis} aria-hidden="true">
              ...
            </span>
          )}
          <noscript className={styles.hiddenDescription}>
            {description}
          </noscript>
          <p
            aria-hidden={!expanded}
            className={classNames(styles.hide, {
              [styles.expanded]: expanded
            })}
          >
            {description}
          </p>
          <div
            className={classNames(styles.icon, {
              [styles.iconUp]: expanded
            })}
          />
        </div>
      </button>
    </div>
  );
};

CategoryHeaderDescription.propTypes = {
  description: PropTypes.string,
  viewport: PropTypes.string.isRequired,
  device: PropTypes.string
};

export default CategoryHeaderDescription;
